export enum LogLineType {
    Information = 0,
    Warning = 1,
    Error = 2
}